var map = {
	"./black/unMute_camera2.png": "Ji1K",
	"./blue/unMute_camera2.png": "Shui",
	"./white/unMute_camera2.png": "2Dla"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "q8/w";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/unMute_camera2\.png$
// module id = q8/w
// module chunks = 24